jQuery(document).ready(function() {
  // Set up Home slider

  var homeSlider = jQuery('.home-slides').bxSlider({
    captions: true,
    controls: false,
    auto: true,
    pause: 8000,
    responsive: true,
    touchEnabled: false,
    pager: true,
    adaptiveHeight: false,
    preloadImages: 'visible',
    nextSelector:'.slider-next',
    prevSelector:'.slider-prev'
    // onSliderLoad: function(slider) {
    //   this.find('.slide-content').css('bottom', '-75%');
    // },
    // onSlideBefore: function(slider) {
    //   this.find('.slide-content').css('bottom', '0%');
    // }
    // onSlideBefore: function(slider) {
    //   this.find('.slide-content').css('bottom', '0');
    // }
  });

  // Set up slider controls
    jQuery('.slider-next').click(function(){
      homeSlider.goToNextSlide();
      return false;
    });

    jQuery('.slider-prev').click(function(){
      homeSlider.goToPrevSlide();
      return false;
    });

// Remove price cell from archive table
  // jQuery(".wc-product-table th:last-child, .wc-product-table td:last-child").remove();

// Set up accordions
   jQuery('.accordion_heading').click(function() {
   if (jQuery(this).parent().is('.open')){
     jQuery(this).closest('.page-accordion').find('.accordion_content_container').animate({'height':'0'},300);
     jQuery(this).closest('.page-accordion').removeClass('open');
     jQuery(this).parent().find('.accordion-button-icon').removeClass('fa-minus').addClass('fa-plus');
   }
   else {
   var newHeight =jQuery(this).closest('.page-accordion').find('.accordion_content').height() + 25 +'px';
     jQuery(this).closest('.page-accordion').find('.accordion_content_container').animate({'height':newHeight},300);
     jQuery(this).closest('.page-accordion').addClass('open');
     jQuery(this).parent().find('.accordion-button-icon').removeClass('fa-plus').addClass('fa-minus');
   }
   });
});
